import { Typography } from "@mui/material";

import { formatFieldValue } from "./discrepancyValueFormat";

/** The intended correction, using the same units and formatting as source comparisons. */
export function ManifestCorrectionValue({
  field,
  value,
}: {
  field: string;
  value?: string | null;
}) {
  return (
    <Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>
      Should be: {formatFieldValue(field, value)}
    </Typography>
  );
}
